const EN = {
    home: {
        configurationAndPlayground: 'Configuration & Interactive Playground',
        interactivePlayground: 'Interactive Playground',
        configuration: 'Configuration',
        configurationToggle: 'I\'m done configuring! Show me the installation guide.',
        installationInstructions: 'Installation Instructions',
    },
    global: {
        basicSettings: 'Basic settings',
        style: 'Style',
        backgroundColor: 'Background color',
        padding: 'Padding',
        borderRadius: 'Border radius',
        textColor: 'Text color',
        borderColor: 'Border color',
        highlightQueryTerms: 'Highlight query terms',
        showImages: 'Show images',
        left: 'Left',
        top: 'Top',
        position: 'Position'
    },
    general: {
		style: 'Style',
		themeColor: 'Theme color',
		accentColor: 'Accent color',
        loadingAnimation: 'Loading animation',
        skeleton: 'Skeleton',
        circle: 'Pulsating circle',
        square: 'Flipping square',
        skeletonHint: 'A grey skeleton screen (outlining the future search layout) will be shown.',
        animationSpeed: 'Animation speed',
        speedFast: 'Fast',
        speedMedium: 'Medium',
        speedSlow: 'Slow',
        tracking: 'Tracking',
        ss360Enhanced: 'SS360 enhanced',
        ga: 'Google Analytics',
        gtm: 'Google Tag Manager',
		allowCookies: 'Allow cookies',
		interfaceLanguage: 'Search interface language',
		additionalCss: 'Additional CSS'
    },
    menu: {
        general: 'General',
        searchBox: 'Search Box',
        suggestions: 'Suggestions',
        results: 'Results',
        filters: 'Filters',
        navigation: 'Navigation'
    },
    searchBox: {
        showIcon: 'Show icon',
        iconColor: 'Icon color',
        showButton: 'Show button',
        placeholder: 'Placeholder',
        search: 'Search',
        buttonIconColor: 'Button icon color',
        buttonIconPadding: 'Button icon padding',
        textSize: 'Text size',
        voiceSearch: 'Voice Search',
        enabled: 'Enabled',
        language: 'Language',
        languages: {
            cs: 'Czech',
            da: 'Danish',
            nl: 'Dutch',
            'en-gb': 'English (UK)',
            'en-US': 'English (US)',
            fi: 'Finnish',
            de: 'German',
            el: 'Greek',
            hu: 'Hungarian',
            it: 'Italian',
            lv: 'Latvian',
            lt: 'Lithuanian',
            no: 'Norwegian',
            pt: 'Portuguese',
            ro: 'Romanian',
            ru: 'Russian',
            es: 'Spanish',
            sv: 'Swedish',
			tr: 'Turkish',
			'fr-FR': 'French'
		},
		en: 'English',
        microphoneColor: 'Microphone color'
    },
    suggestions: {
        show: 'Show search suggestions',
        minChars: 'Minimum characters',
        num: 'Number of suggestions',
        appendSearchButton: 'Append search button',
        showAll: 'Show All',
        suggestionsLayover: 'Show mobile suggestions as layover',
        scrollToSearchBox: 'Scroll to mobile search box after focus',
        distanceToSearchBox: 'Distance to search box',
    },
    results: {
        layover: 'Layover',
        embed: 'Embed',
        fullscreen: 'Fullscreen',
        searchResultPage: 'Search result page URL',
        linksOpenNewTab: 'Link opens new tab',
        redirectOnSingle: 'Redirect on single result',
        hideResultsWithoutImages: 'Hide results without images',
        showSearchBox: 'Show search box in layover',
        num: 'Number of results',
        showAll: 'Show all results at once',
        moreResultsButton: 'More results button text',
        showMoreResults: 'Show more results',
        infiniteScroll: 'Inifinite scroll',
        pageSize: 'Page size',
        texts: 'Texts',
        caption: 'Search result caption',
        queryCorrection: 'Query correction text',
        noResults: 'No results text',
        fullscreenCaption: 'Fullscreen caption',
        fullscreenCaptionText: 'Search this site',
        layout: 'Layout',
        mobile: 'Mobile (below 992px)',
        desktop: 'Desktop'
    },
    layout: {
        type: 'Layout type',
        list: 'List',
        grid: 'Grid',
        masonry: 'Masonry',
        showUrl: 'Show URL',
        showSnippet: 'Show snippet',
        showTitle: 'Show title',
        columnCount: 'Column count',
        default: 'default',
        bp: 'px and below'
    },
    filters: {
        enabled: 'Use filters',
        position: 'Position',
        label: 'Label',
        showCounts: 'Show counts',
        showQuickDeleteBar: 'Show quick delete bar',
        clearAllLabel: '\'Clear all\' label',
		auto: 'Auto',
		toggleButtonLabel: 'Filter results'
    },
    navigation: {
        groupResults: 'Group results',
        none: 'None',
        type: 'Type',
        scroll: 'Scroll',
        tabs: 'Tabs',
        forceTabs: 'Force tabs on desktop (even for 6 and more groups)',
        spaceBetweenTabs: 'Space between tabs',
        tabBorderRadius: 'Tab border radius',
        tabTitle: 'Tab title'
    },
    presets: {
        label: 'Presets',
        restoreDefaults: 'Restore Defaults',
        undo: 'Undo',
        minimal: 'Minimal',
        advanced: 'Advanced',
        flat: 'Flat',
        rounded: 'Rounded'
    },
    preview: {
        desktopUnavailable: 'Desktop Preview is not available for your screen resolution',
        mobileUnavailable: 'Mobile Preview is not available for your screen resolution'
    },
    misc: {
        copyToClipboard: 'Copy to clipboard'
    },
    faqs: {
        searchBoxQuestion: 'Don\'t have a search box yet?',
        searchBoxSolution: 'Add following code to your site and leave the Search Box Selector (above) blank:',
        searchBoxWp: 'You can also use the following shortcode to add a search box to a post or page:',
        searchButtonQuestion: 'Don\'t have a search button yet?',
        searchButtonSolution: 'Add following code to your site (next to the search field) and leave the Search Button Selector (above) blank:',
        searchButtonWp: 'You can also use the following shortcode to add a search button to a post or page:',
        searchButtonLabel: 'Search',
        triggerQuestion: 'Don\'t have a search trigger yet?',
        triggerSolution: 'Add following code to your site and leave the Search Trigger Selector (above) blank:',
		triggerLabel: 'Click To Search',
		searchBoxSection: 'If you want the search box to look exactly like the one in the layover popup (with default Site Search 360 styling already applied), use the following code snippet and paste it wherever you want the search box to be displayed on your site.',
		searchBoxControls: 'If you\'ve used the Search Designer controls to fine-tune the look and feel of your search box and you\'re happy with the way it looks in the preview above, use the following code instead:',
		searchBoxControlsHint: 'To show only the box (search results are triggered by the Enter key in this case):',
		searchBoxAndButtonHint: 'To show both a search box and a button:',
		postInstallHint: 'Your Search Designer styling will be applied as soon as the search scripts are also added to your site.'
    },
    intro: {
        heading: 'Search design - Better site-search, better style',
        about: 'Whether you want to make your search box a focal point of your site or put it to work undercover, seamlessly fitting into your design, our Search Designer tool will help you getting your site search looking exactly how you want it.',
        simple: 'With our simple configure, preview, deploy process, it’s as easy as 1-2-3.',
    },
    lowResolution: {
        bullet1: 'Search box and search result customization',
        bullet2: 'Live preview',
        bullet3: 'Automatically generated configuration',
        mobile: 'Oh no, you\'re on a mobile device, aren\'t you?',
        forgetIt: 'We are sorry, but the live and interactive preview wouldn\'t work properly on your current device. Just grab a cup of coffee and switch to your desktop to do the hard work.'
    },
    installation: {
        step: 'Step',
        createAccount: 'Create a Site Search 360 Account…',
        unlessYouHaveOne: '…unless you have one',
        signUp: 'Sign Up',
        detailsPrompt: 'Give us some basic details',
        detailsPromptHint: '(You can skip this step and manually adjust the ss360Config. But this will make it easier for you!)',
        siteId: 'Site ID',
        searchBoxSelector: 'Search Box Selector',
        searchButtonSelector: 'Search Button Selector',
        searchResultContainerSelector: 'Search Result Container Selector',
        searchTriggerSelector: 'Search Trigger Selector',
        integrationInstructionsWp: 'Import the Search Designer configuration in the Site Search 360 WordPress search plugin…',
        integrationInstructionsWp2: '…or copy and paste the following config in the Configuration Editor of the Site Search 360 WordPress search plugin.',
        enjoy: 'Enjoy your',
        updatedStyles: 'updated styles',
		newSiteSearch: 'new Site Search (360)',
		integrationInstructions: 'Add or replace Site Search 360 scripts on your site',
		siteIdDetailsPromptHint: 'Once you sign up, you can find your Site ID under Account > Profile. The search won\'t work if the Site ID is missing.',
		selectorHelper: 'CSS selectors connect our search engine to an actual search form element on your site (search box with or without a button). If you don\'t have one yet, check the "Don\'t have a search box yet?" instructions below.',
		embedHint: 'This selector should point to an element on your search result page where results will be rendered (embedded). If you don’t have one yet, you can add this code',
		fullscreenHint: 'This selector should point to an element on your site (usually a search icon) so when a user clicks on it, it would trigger the Site Search 360 fullscreen results. To use our default selector, give your search icon the following'
    }
};

const FR = {
    home: {
        configurationAndPlayground: 'Configuration et aire de jeux interactifs',
        interactivePlayground: 'Aire de jeux interactifs',
        configuration: 'Configuration',
        configurationToggle: 'J\'en ai fini avec la configuration ! Montrez-moi le guide d\'installation.',
        installationInstructions: 'Consignes d\'installation',
    },
    global: {
        basicSettings: 'Paramètres de base',
        style: 'Style',
        backgroundColor: 'Couleur de fond',
        padding: 'Padding',
        borderRadius: 'Rayon de bordure',
        textColor: 'Couleur du texte',
        borderColor: 'Couleur de la bordure',
        highlightQueryTerms: 'Surligner les termes de la requête',
        showImages: 'Montrer des images',
        left: 'Gauche',
        top: 'En haut',
        position: 'Position'
    },
    general: {
		style: 'Style',
		themeColor: 'Couleur de thème',
		accentColor: 'Couleur d\'accent',
        loadingAnimation: 'Chargement de l\'animation',
        skeleton: 'Squelette',
        circle: 'Cercle pulsatile',
        square: 'Carré inversé',
        skeletonHint: 'Un écran squelette gris (décrivant la future mise en page de la recherche) s\'affichera.',
        animationSpeed: 'Vitesse de l\'animation',
        speedFast: 'Rapide',
        speedMedium: 'Moyenne',
        speedSlow: 'Lente',
        tracking: 'Suivi',
        ss360Enhanced: 'SS360 amélioré',
        ga: 'Google Analytics',
        gtm: 'Google Tag Manager',
		allowCookies: 'Autoriser les cookies',
		additionalCss: 'CSS supplémentaires',
		interfaceLanguage: 'Langue de l\'interface de recherche'
    },
    menu: {
        general: 'Général',
        searchBox: 'Champ de recherche',
        suggestions: 'Suggestions',
        results: 'Résultats',
        filters: 'Filtres',
        navigation: 'Navigation'
    },
    searchBox: {
        showIcon: 'Afficher l\'icône',
        iconColor: 'Couleur de l\'icône',
        showButton: 'Afficher le bouton',
        placeholder: 'Texte de remplissage',
        search: 'Recherche',
        buttonIconColor: 'Couleur du bouton-icône',
        buttonIconPadding: 'Padding du bouton-icône',
        textSize: 'Taille du texte',
        voiceSearch: 'Recherche vocale',
        enabled: 'Activée',
        language: 'Langue',
        languages: {
            cs: 'Tchèque',
            da: 'Danois',
            nl: 'Nééerlandais',
            'en-gb': 'Anglais (Royaume-Uni)',
			'en-US': 'Anglais (US)',
            fi: 'Finnois',
            de: 'Allemand',
            el: 'Grec',
            hu: 'Hongrois',
            it: 'Italien',
            lv: 'Letton',
            lt: 'Lituanien',
            no: 'Norvégien',
            pt: 'Portugais',
            ro: 'Roumain',
            ru: 'Russe',
            es: 'Espagnol',
            sv: 'Suédois',
			tr: 'Turc',
			'fr-FR': 'Française'
		},
		en: 'Anglais',
        microphoneColor: 'Couleur du microphone'
    },
    suggestions: {
        show: 'Afficher les suggestions de recherche',
        minChars: 'Caractères minimum',
        num: 'Nombre de suggestions',
        appendSearchButton: 'Ajouter un bouton de recherche',
        showAll: 'Tout afficher',
        suggestionsLayover: 'Afficher les suggestions mobiles en pop-up de couverture',
        scrollToSearchBox: 'Faites défiler jusqu\'au champ de recherche mobile après la mise au point',
        distanceToSearchBox: 'Distance jusqu\'au champ de recherche',
    },
    results: {
        layover: 'Pop-up de couverture',
        embed: 'Intégrée',
        fullscreen: 'Plein écran',
        searchResultPage: 'URL de la page de résultats de recherche',
        linksOpenNewTab: 'Le lien ouvre un nouvel onglet',
        redirectOnSingle: 'Rediriger sur un seul résultat',
        hideResultsWithoutImages: 'Masquer les résultats sans images',
        showSearchBox: 'Afficher le champ de recherche en couverture',
        num: 'Nombre de résultats',
        showAll: 'Afficher tous les résultats en même temps',
        moreResultsButton: 'Texte du bouton Plus de résultats',
        showMoreResults: 'Afficher plus de résultats',
        infiniteScroll: 'Défilement infini',
        pageSize: 'Taille de page',
        texts: 'Textes',
        caption: 'Légende des résultats de recherche',
        queryCorrection: 'Texte de correction de la requête',
        noResults: 'Aucun texte de résultats',
        fullscreenCaption: 'Légende plein écran',
        fullscreenCaptionText: 'Rechercher sur ce site',
        layout: 'Mise en page',
        mobile: 'Mobile (moins de 992px)',
        desktop: 'Ordinateur de bureau'
    },
    layout: {
        type: 'Type de mise en page',
        list: 'Liste',
        grid: 'Grille',
        masonry: 'Maçonnerie',
        showUrl: 'Afficher l\'URL',
        showSnippet: 'Afficher l\'extrait',
        showTitle: 'Afficher le titre',
        columnCount: 'Nombre de colonnes',
        default: 'Défaut',
        bp: 'px et moins'
    },
    filters: {
        enabled: 'Utiliser des filtres',
        position: 'Position',
        label: 'Intitulé',
        showCounts: 'Afficher les chiffres',
        showQuickDeleteBar: 'Afficher la barre de suppression rapide',
        clearAllLabel: 'Intitulé \'Tout effacer\'',
		auto: 'Auto',
		toggleButtonLabel: 'Filtrer les résultats'
    },
    navigation: {
        groupResults: 'Grouper les résultats',
        none: 'Aucun',
        type: 'Type',
        scroll: 'Faites défiler',
        tabs: 'Onglets',
        forceTabs: 'Forcer les onglets sur le bureau (même pour 6 groupes et plus)',
        spaceBetweenTabs: 'Espace entre les onglets',
        tabBorderRadius: 'Rayon de la bordure de l\'onglet',
        tabTitle: 'Titre de l\'onglet'
    },
    presets: {
        label: 'Préréglage(s)',
        restoreDefaults: 'Restaurer les valeurs par défaut',
        undo: 'Annuler',
        minimal: 'Minimal(aux)',
        advanced: 'Avancé(s)',
        flat: 'À plat',
        rounded: 'Arrondi(s)'
    },
    preview: {
        desktopUnavailable: 'L\'aperçu du bureau n\'est pas disponible pour votre résolution d\'écran',
        mobileUnavailable: 'L\'aperçu mobile n\'est pas disponible pour votre résolution d\'écran.'
    },
    misc: {
        copyToClipboard: 'Copier dans le presse-papiers'
    },
    faqs: {
        searchBoxQuestion: 'Vous n\'avez pas de champ de recherche ?',
        searchBoxSolution: 'Ajoutez le code qui suit à votre site Web et laissez le sélecteur de champ (ci-dessus) vide :',
        searchBoxWp: 'Vous pouvez aussi utiliser le shortcode suivant pour ajouter un champ de recherche à un message ou à une page :',
        searchButtonQuestion: 'Vous n\'avez pas de bouton de recherche ?',
        searchButtonSolution: 'Ajoutez le code suivant à votre site (à côté du champ de recherche) et laissez le sélecteur de champ (ci-dessus) vide :',
        searchButtonWp: 'Vous pouvez aussi utiliser le shortcode suivant pour ajouter un bouton de recherche à un message ou une page :',
        searchButtonLabel: 'Recherche',
        triggerQuestion: 'Vous n\'avez pas de déclencheur de recherche ?',
        triggerSolution: 'Ajouter le code suivant à votre site et laissez le sélecteur de champ (ci-dessus) vide :',
		triggerLabel: 'Cliquez pour lancer la recherche',
		searchBoxSection: 'Si vous souhaitez que le champ de recherche ressemble exactement à celui du popup contenant les résultats (avec le style par défaut de Site Search 360 déjà appliqué), utilisez le code suivant et collez-le à l\'endroit où vous souhaitez afficher le champ de recherche sur votre site.',
		searchBoxControls: 'Si vous avez changé les paramètres du Créateur de recherche pour affiner l\'apparence de votre boîte de recherche et que vous en êtes satisfait dans l\'aperçu ci-dessus, utilisez plutôt le code suivant :',
		searchBoxControlsHint: 'Pour afficher uniquement une boîte (les résultats de la recherche sont déclenchés par la touche Entrée dans ce cas) :',
		searchBoxAndButtonHint: 'Pour afficher à la fois une boîte de recherche et un bouton :',
		postInstallHint: 'Vos styles seront appliqués à votre champ de recherche dès que les scripts de recherche seront également ajoutés à votre site.'
    },
    intro: {
        heading: 'La création de recherche - Une recherche sur site améliorée, un style amélioré',
        about: 'Que vous souhaitiez faire de votre champ de recherche un point de mire de votre site ou le faire travailler en coulisses, en l\'intégrant parfaitement à votre design, notre outil de Créateur de recherche vous aidera à concevoir une recherche sur site qui correspond totalement à vos attentes.',
        simple: 'Avec notre processus simple de configuration, de prévisualisation et de déploiement, c\'est simple comme bonjour.',
    },
    lowResolution: {
        bullet1: 'Champ de recherche et personnalisation du résultat de recherche',
        bullet2: 'Prévisualisation en direct',
        bullet3: 'Configuration automatique',
        mobile: 'Oh non, vous êtes sur un appareil mobile, n\'est-ce pas ?',
        forgetIt: 'Nous sommes désolés, mais la prévisualisation interactive et en direct ne fonctionnera pas correctement sur votre appareil actuel. Il vous suffit de prendre un café et de passer à votre bureau pour effectuer le travail complexe.'
    },
    installation: {
        step: 'Étape',
        createAccount: 'Créez un compte Site Search 360…',
        unlessYouHaveOne: '…à moins que vous n\'en ayez déjà un',
        signUp: 'S\'inscrire',
        detailsPrompt: 'Donnez-nous quelques informations de base',
        detailsPromptHint: '(Vous pouvez sauter cette étape et configurer ss360config manuellement, mais elle vous facilitera la tâche !)',
        siteId: 'ID de site',
        searchBoxSelector: 'Sélecteur de champ',
        searchButtonSelector: 'Sélecteur de bouton de recherche',
        searchResultContainerSelector: 'Sélecteur de conteneur de résultat',
        searchTriggerSelector: 'Sélecteur de déclencheur de recherche',
        integrationInstructions2: '…ou remplacez le script existant de Site Search 360 si vous en avez un.',
        integrationInstructionsWp: 'Importez la configuration du Créateur de recherche dans le plugin WordPress de Site Search 360…',
        integrationInstructionsWp2: '…ou copiez et collez la configuration suivante dans l\'Éditeur de configuration du plugin de recherche WordPress de Site Search 360.',
        enjoy: 'Profitez de',
        updatedStyles: 'Vos styles actualisés',
		newSiteSearch: 'Votre nouveau Site Search (360)',
		integrationInstructions: 'Ajoutez ou remplacez les scripts de Site Search 360 sur votre site',
		siteIdDetailsPromptHint: 'Une fois inscrit, vous pouvez trouver votre ID de site sous Compte > Profil. La recherche ne fonctionnera pas si votre ID de site est manquant.',
		selectorHelper: 'Les sélecteurs CSS connectent notre moteur de recherche à un champ de recherche réel sur votre site (une boîte avec ou sans bouton). Si vous n\'en avez pas encore, consultez les instructions \"Vous n\'avez pas de champ de recherche ?\"',
		embedHint: 'Ce sélecteur doit pointer vers un élément de la page de votre site où les résultats seront rendus (intégrés). Si vous n\'en avez pas encore, vous pouvez ajouter ce code-là',
		fullscreenHint: 'Ce sélecteur doit pointer sur un élément de votre site (généralement une icône de recherche) de sorte que lorsqu\'un utilisateur clique dessus, il déclenche les résultats de Site Search 360 en plein écran. Pour utiliser notre sélecteur par défaut, donnez à votre icône de recherche un'
    }
};

const DE = {
    home: {
        configurationAndPlayground: 'Konfiguration & Interactive Playground',
        interactivePlayground: 'Interactive Playground',
        configuration: 'Konfiguration',
        configurationToggle: 'Ich bin fertig mit der Konfiguration! Zeig mir die Installationsanleitung.',
        installationInstructions: 'Installationsanleitung',
    },
    global: {
        basicSettings: 'Grundeinstellungen',
        style: 'Stil',
        backgroundColor: 'Hintergrundfarbe',
        padding: 'Padding',
        borderRadius: 'Eckenrundung',
        textColor: 'Textfarbe',
        borderColor: 'Rahmenfarbe',
        highlightQueryTerms: 'Suchbegriffe hervorheben',
        showImages: 'Bilder anzeigen',
        left: 'Links',
        top: 'Oben',
        position: 'Position'
    },
    general: {
		style: 'Stil',
		themeColor: 'Themenfarbe',
		accentColor: 'Akzentfarbe', 
        loadingAnimation: 'Ladeanimation',
        skeleton: 'Skeleton Screen',
        circle: 'Pulsating Circle',
        square: 'Flipping Square',
        skeletonHint: 'Ein Skeleton Screen, der das ladende Layout der Suche darstellt, wird angezeigt.',
        animationSpeed: 'Animationsgeschwindigkeit',
        speedFast: 'Schnell',
        speedMedium: 'Mittel',
        speedSlow: 'Langsam',
        tracking: 'Tracking',
        ss360Enhanced: 'SS360 enhanced',
        ga: 'Google Analytics',
        gtm: 'Google Tag Manager',
		allowCookies: 'Cookies erlauben',
		additionalCss: 'Zusätzliche Styles',
		interfaceLanguage: 'Sprache (Suchinterface)' 
    },
    menu: {
        general: 'Allgemeines',
        searchBox: 'Suchfeld',
        suggestions: 'Vorschläge',
        results: 'Ergebnisse',
        filters: 'Filter',
        navigation: 'Navigation'
    },
    searchBox: {
        showIcon: 'Lupe im Suchfeld',
        iconColor: 'Lupenfarbe',
        showButton: 'Button anzeigen',
        placeholder: 'Platzhaltertext',
        search: 'Suchen',
        buttonIconColor: 'Lupenfarbe im Button',
        buttonIconPadding: 'Padding im Button',
        textSize: 'Schriftgröße',
        voiceSearch: 'Sprachsuche',
        enabled: 'Aktiv',
        language: 'Sprache',
        languages: {
            cs: 'Tschechisch',
            da: 'Dänisch',
            nl: 'Niederländisch',
            'en-gb': 'Englisch (UK)',
            'en-US': 'Englisch (US)',
            fi: 'Finnisch',
            de: 'Deutsch',
            el: 'Griechisch',
            hu: 'Ungarisch',
            it: 'Italienisch',
            lv: 'Lettisch',
            lt: 'Litauisch',
            no: 'Norwegisch',
            pt: 'Portugiesisch',
            ro: 'Rumänisch',
            ru: 'Russisch',
            es: 'Spanisch',
            sv: 'Schwedisch',
			tr: 'Türkisch',
			'fr-FR': 'Französisch'
		},
		en: 'Englisch',
        microphoneColor: 'Mikrofon Farbe'
    },
    suggestions: {
        show: 'Suchvorschläge anzeigen',
        minChars: 'Mindestanzahl von Zeichen',
        num: 'Anzahl von Vorschlägen',
        appendSearchButton: '"Weitere Ergebnisse"-Button anzeigen',
        showAll: 'Alle anzeigen',
        suggestionsLayover: 'Mobile Vorschläge als Layover anzeigen',
        scrollToSearchBox: 'Nach Fokus zum mobilen Suchfeld scrollen',
        distanceToSearchBox: 'Entfernung zum Suchfeld',
    },
    results: {
        layover: 'Layover',
        embed: 'Einbinden',
        fullscreen: 'Vollbild',
        searchResultPage: 'URL zur Suchergebnisseite',
        linksOpenNewTab: 'Link öffnet in neuem Fenster',
        redirectOnSingle: 'Umleiten, wenn nur 1 Ergebnis gefunden wird',
        hideResultsWithoutImages: 'Ergebnisse ohne Bilder verbergen',
        showSearchBox: 'Suchfeld in Layover anzeigen',
        num: 'Anzahl der Ergebnisse',
        showAll: 'Alle Ergebnisse auf einmal zeigen',
        moreResultsButton: 'Text für "Weitere Ergebnisse"-Button',
        showMoreResults: 'Weitere Ergebnisse',
        infiniteScroll: 'Infinite Scroll',
        pageSize: 'Seitengröße',
        texts: 'Texte',
        caption: 'Überschrift der Suchergebnisse',
        queryCorrection: 'Text der Rechtschreibkorrektur',
        noResults: 'Text für leere Ergebnisseite',
        fullscreenCaption: 'Überschrift im Vollbildmodus',
        fullscreenCaptionText: 'Diese Seite durchsuchen',
        layout: 'Layout',
        mobile: 'Mobil (unter 992px)',
        desktop: 'Desktop'
    },
    layout: {
        type: 'Layouttyp',
        list: 'Liste',
        grid: 'Grid',
        masonry: 'Masonry',
        showUrl: 'URL anzeigen',
        showSnippet: 'Snippet anzeigen',
        showTitle: 'Titel anzeigen',
        columnCount: 'Spaltenanzahl',
        default: 'default',
        bp: 'px und weniger'
    },
    filters: {
        enabled: 'Filter benutzen',
        position: 'Position',
        label: 'Name', 
        showCounts: 'Anzahl anzeigen', 
        showQuickDeleteBar: 'Schnelllöschleiste anzeigen',
        clearAllLabel: '\'Alle zurücksetzen\' Text',
		auto: 'Auto',
		toggleButtonLabel: 'Ergebnisse filtern'
    },
    navigation: {
        groupResults: 'Ergebnisse gruppieren',
        none: 'Keine',
        type: 'Typ', 
        scroll: 'Scroll',
        tabs: 'Tabs',
        forceTabs: 'Tabs am Desktop erzwingen (selbst für 6 oder mehr Gruppen)',
        spaceBetweenTabs: 'Abstand zwischen Tabs',
        tabBorderRadius: 'Eckenrundung der Tabs',
        tabTitle: 'Tab-Titel'
    },
    presets: {
        label: 'Voreinstellungen',
        restoreDefaults: 'Standardeinstellungen wiederherstellen',
        undo: 'Rückgängig',
        minimal: 'Minimal',
        advanced: 'Fortgeschritten',
        flat: 'Flach',
        rounded: 'Gerundet'
    },
    preview: {
        desktopUnavailable: 'Die Desktop-Vorschau ist nicht verfügbar für Deine Bildschirmauflösung',
        mobileUnavailable: 'Die Mobil-Vorschau ist nicht verfügbar für Deine Bildschirmauflösung'
    },
    misc: {
        copyToClipboard: 'in Zwischenablage kopieren'
    },
    faqs: {
        searchBoxQuestion: 'Noch kein Suchfeld?',
        searchBoxSolution: 'Füge diesen Code zu Deiner Seite hinzu und lass den Suchfeldselektor (oben) leer:',
        searchBoxWp: 'Du kannst den folgenden Shortcode benutzen um ein Suchfeld zu einem Artikel oder zu einer Seite hinzuzufügen:',
        searchButtonQuestion: 'Du hast keinen Suchbutton?',
        searchButtonSolution: 'Füge diesen Code zu Deiner Seite (neben dem Suchfeld) hinzu und lass den Suchbuttonselektor (oben) leer:',
        searchButtonWp: 'Du kannst den folgenden Shortcode benutzen um einen Suchbutton zu einem Artikel oder zu einer Seite hinzuzufügen:',
        searchButtonLabel: 'Suchen',
        triggerQuestion: 'Du hast keinen Suchauslöser?',
        triggerSolution: 'Füge diesen Code zu Deiner Seite hinzu und lass den Suchauslöserselektor (oben) leer:',
		triggerLabel: 'Klick zum suchen',
		searchBoxSection: 'Wenn das Suchfeld genau so wie im Layover-Popup (mit dem Site Search 360 Standard-Styling Site Search 360) aussehen soll, verwende den folgenden Code-Snippet und füge ihn an der Stelle ein, an der das Suchfeld auf Deiner Website angezeigt werden soll.',
		searchBoxControls: 'Wenn Du den Suchdesigner zum Anpassen des Aussehens Deines Suchfelds verwendet hast, und Du mit dem Aussehen in der Vorschau oben zufrieden bist, verwende stattdessen den folgenden Code:',
		searchBoxControlsHint: 'Um nur das Suchfeld anzuzeigen (Suchergebnisse werden in diesem Fall durch die Eingabetaste ausgelöst):',
		searchBoxAndButtonHint: 'Um sowohl ein Suchfeld als auch ein Suchbutton anzuzeigen:',
		postInstallHint: 'Das Styling aus dem Suchdesigner wird angewendet, sobald die Suchskripte auch in Deine Website eingefügt werden.'
    },
    intro: {
        heading: 'Search Design - bessere Site-Search, besserer Stil',
        about: 'Soll Dein Suchfeld im Fokus stehen oder eher im Geheimen arbeiten? Egal wie Du Deine Site-Search gestalten willst, unser Search Designer unterstützt Dich, damit Deine Suche perfekt zu Deinem Design passt.',
        simple: 'Bei uns ist jeder Schritt von der Konfiguration bis zum Livegang so einfach wie 1-2-3.',
    },
    lowResolution: {
        bullet1: 'Suchfeld- und Suchergebnisanpassung',
        bullet2: 'Livevorschau',
        bullet3: 'Automatisch generierte Konfiguration',
        mobile: 'Ups, Du nutzt gerade ein mobiles Gerät, oder?',
        forgetIt: 'Es tut uns leider, aber die Livevorschau würde nicht mit Deinem aktuellen Gerät richtig funktionieren. Hol dir einfach eine Tasse Kaffee, setz dich vor den Bildschirm und mache die harte Arbeit.'
    },
    installation: {
        step: 'Schritt',
        createAccount: 'Erstell ein Site Search 360 Konto…',
        unlessYouHaveOne: '…außer Du hast schon eins',
        signUp: 'Registrieren',
        detailsPrompt: 'Gib uns ein paar Details',
        detailsPromptHint: '(Du kannst diesen Schritt überspringen und die ss360Config manuell anpassen. Aber diese Methode macht alles einfacher für Dich!)',
        siteId: 'Site ID',
        searchBoxSelector: 'Suchfeldselektor',
        searchButtonSelector: 'Suchbuttonselektor',
        searchResultContainerSelector: 'Suchergebnis-Containerselektor',
        searchTriggerSelector: 'Suchauslöserselektor',
        integrationInstructions2: '…oder ersetze ein bestehendes Site Search 360-Script wenn Du eins hast',
        integrationInstructionsWp: 'Importiere die \'Search Designer\'-Konfiguration in das Site Search 360 WordPress Suchplugin…',
        integrationInstructionsWp2: '…oder kopiere die folgende config und füge sie in den Konfigurationseditor des Site Search 360 WordPress Plugin ein.',
        enjoy: 'Genieße Deine',
        updatedStyles: 'aktualisierte Styles',
		newSiteSearch: 'neue Site Search (360)',

		integrationInstructions: 'Füge ein oder ersetze Site Search 360 Skripte auf deiner Webseite',
		siteIdDetailsPromptHint: 'Sobald Du Dich angemeldet hast, findest Du Deine Site ID unter Konto > Profil. Die Suche funktioniert nicht, wenn die Site ID fehlt.',
		selectorHelper: 'CSS-Selektoren verbinden unsere Suchmaschine mit dem Suchinput auf Deiner Website (Suchfeld mit oder ohne Suchbutton). Wenn Du noch kein Suchfeld hast, überprüfe die Anleitung \"Noch kein Suchfeld?\" weiter unten.',
		embedHint: 'Dieser Selektor sollte auf ein Element auf Deiner Suchergebnisseite zeigen, in dem die Ergebnisse gerendert (eingebettet) werden. Wenn Du noch keinen hast, kannst Du diesen Code hinzufügen',
		fullscreenHint: 'Dieser Selektor sollte auf ein Element auf Deiner Website zeigen (normalerweise ein Such-Icon), so dass, wenn ein Benutzer darauf klickt, die Vollbild-Ergebnisse der Site Search 360 ausgelöst werden. Um unseren Standard-Selektor zu verwenden, füge Deinem Such-Icon folgendes Attribut'
	}
	
};

export default {
    EN,
	FR,
	DE
};


// WEBPACK FOOTER //
// ./src/localization/Texts.js